import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router";
import ProgressiveLoader from "./components/loader/ProgressiveLoader";
import SnackBar from "./components/snack-bar/SnackBar";
import { getParams } from "./utlis/helpers";
import { getCustomTheme } from "./services/websiteApi";

const App = () => {
  const { loading, error } = useSelector((state) => state.global);
  const [loadingTheme, setLoadingTheme] = useState(false);
  const { providerId, adminId, clientId } = getParams();
  const callThemeAPI = async () => {
    await getCustomTheme()
      .then((res) => {
        sessionStorage.setItem("customtheme", JSON.stringify(res?.data?.data));
        document.documentElement.style.setProperty(
          "--primary-color",
          res?.data?.data?.primaryColorCode,
        );
        document.documentElement.style.setProperty(
          "--secondary-color",
          res?.data?.data?.secondaryColorCode,
        );
        setLoadingTheme(true);
      })
      .catch(() => {
        setLoadingTheme(true);
      });
  };
  useEffect(() => {
    if (providerId && adminId && clientId) {
      callThemeAPI();
    } else {
      setLoadingTheme(true);
    }
  }, []);

  return (
    <>
      {loadingTheme && <Outlet />}
      {loading && <ProgressiveLoader loader={loading} />}
      <SnackBar error={error} />
    </>
  );
};

export default App;
